export enum ETouchTriggerNotSentReason {
  CampaignInactive = 'CAMPAIGN_INACTIVE', // Campaign wasn't active at the time the touch was processed
  MarketingProfileIncomplete = 'MARKETING_PROFILE_INCOMPLETE', // User's marketing profile was incomplete at the time the touch was processed
  RequiredCustomTouchTemplateMissing = 'REQUIRED_CUSTOM_TOUCH_TEMPLATE_MISSING',
  ExtraTouchPaymentFailed = 'EXTRA_TOUCH_PAYMENT_FAILED',
}

export enum EVoicemailTouchBehavior {
  AllLeads = 'ALL_LEADS', // All leads get VMs
  ConsentedLeads = 'CONSENTED_LEADS', // Consented leads get VMs
  NonConsentedLeads = 'NON_CONSENTED_LEADS', // Non-consented leads get VMs
  None = 'NONE', // No one gets VMs, all leads get emails
}

export enum ETouchTriggerContextType {
  Campaign = 'CAMPAIGN',
  CrmPro = 'CRM_PRO',
}

export enum ECampaignTouchTriggerKind {
  System = 'SYSTEM',
  Extra = 'EXTRA',
}

export interface ICampaignTouchTriggerData {
  kind: ECampaignTouchTriggerKind;
  isIntroEmail: boolean;
  systemSequenceNumber?: number;
}

export interface ITouchTrigger {
  _id: string;
  description: string;
  contextType: ETouchTriggerContextType;
  requiresCustomTouchTemplate: boolean;
  campaignTrigger?: ICampaignTouchTriggerData;
  processed?: boolean;
  processing?: boolean;
  processedAt?: string;
  processingNotSentReason?: ETouchTriggerNotSentReason;
  sendAt?: string;
  processAt?: string;
  sendDateDelayed?: boolean;
  metadata: any;
  customTouchTemplate?: any;
  touchType: {
    _id: string;
    name: string;
  };
}
